"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceChange = exports.Product = exports.ESubscriptionType = exports.ESubscriptionPeriod = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
const date_fns_1 = require("date-fns");
var ESubscriptionPeriod;
(function (ESubscriptionPeriod) {
    ESubscriptionPeriod["MONTHLY_SERVICE"] = "monthly";
    ESubscriptionPeriod["ANNUALLY_SERVICE"] = "annually";
    ESubscriptionPeriod["DAILY_SERVICE"] = "daily";
    ESubscriptionPeriod["WEEKLY_SERVICE"] = "weekly";
    ESubscriptionPeriod["MONTHLY_PRODUCT"] = "monthly-product";
    ESubscriptionPeriod["ANNUALLY_PRODUCT"] = "annually-product";
    ESubscriptionPeriod["DAILY_PRODUCT"] = "daily-product";
    ESubscriptionPeriod["WEEKLY_PRODUCT"] = "weekly-product";
    ESubscriptionPeriod["OTHER"] = "other";
    ESubscriptionPeriod["NONE"] = "";
})(ESubscriptionPeriod || (exports.ESubscriptionPeriod = ESubscriptionPeriod = {}));
var ESubscriptionType;
(function (ESubscriptionType) {
    ESubscriptionType["INDIVIDUAL"] = "individual";
    ESubscriptionType["GROUP"] = "group";
    ESubscriptionType["OPS"] = "ops";
    ESubscriptionType["BROKER"] = "broker";
    ESubscriptionType["EXISTING"] = "existing";
    ESubscriptionType["NONE"] = "";
})(ESubscriptionType || (exports.ESubscriptionType = ESubscriptionType = {}));
class Product extends model_core_1.Base {
    name = '';
    description = '';
    notes = '';
    sku = '';
    weight = null;
    weight_ounces = null;
    cost = null;
    nmfc_class = '';
    nmfc_number = '';
    price = null;
    dimensions = new model_core_1.DimensionArray([]);
    url = '';
    image = '';
    address = null;
    subscription = null;
    metadata = {};
    agreement = '';
    _m = ['weight', 'weight_ounces', 'cost', 'price', 'name', 'sku', 'price', 'dimensions', 'metadata', 'address'];
    constructor(data, olMap, type, idLen) {
        super(type || 'products', idLen || 31);
        (0, index_1.setObjectProperties)(this, data, olMap, Product);
    }
    toString() {
        return `Product: ${this.name}`;
    }
    toJSON() {
        if (this.weight_ounces && !this.weight) {
            this.weight = (0, index_1.round)(this.weight_ounces / 16, 1);
        }
        else if (this.weight && !this.weight_ounces) {
            this.weight_ounces = this.weight_ounces * 16;
        }
        let r = super.toJSON();
        ['weight', 'weight_ounces', 'cost', 'price'].forEach(p => {
            r[p] = (this[p] && !isNaN(this[p])) ? Number(this[p]) : this[p] || null;
        });
        r.address = (0, index_1.toMinJSON)(this, 'address');
        return r;
    }
    toMinJSON(ignoreDocRef) {
        let r = super.toMinJSON(ignoreDocRef);
        ['weight', 'weight_ounces', 'cost', 'price'].forEach(p => {
            r[p] = (this[p] && !isNaN(this[p])) ? Number(this[p]) : this[p] || null;
        });
        return r;
    }
}
exports.Product = Product;
class PriceChange extends model_core_1.Base {
    cost_based = null;
    before = null;
    after = null;
    percent = null;
    amount = null;
    constructor(data, olMap) {
        super('changes', null);
        (0, index_1.setObjectProperties)(this, data, olMap, PriceChange);
    }
    toString() {
        return `PriceChange: ${this.before} -> ${this.after}`;
    }
    async save(parent) {
        if (!this.id) {
            this.id = (0, date_fns_1.format)(new Date(), `yyyy-MM-dd'T'HH:mm`);
        }
        return super.save(parent);
    }
}
exports.PriceChange = PriceChange;
index_1.olm.products = (ref, map) => {
    return new Product(ref, map);
};
index_1.olm.changes = (ref, map) => {
    return new PriceChange(ref, map);
};
